enum DownloadActionType {
  IMAGE = 'image',
  CSV = 'csv',
  EXCEL = 'excel',
}

export default DownloadActionType;
